// extracted by mini-css-extract-plugin
export default {"Wrapper":"InputRemovable_Wrapper__y74Fq","Button":"InputRemovable_Button__tDZDr"};